module.exports = __webpack_public_path__ + "media/images/chevron-down-744d1baf.svg";